import React from 'react'
import { useSelector } from 'react-redux'
import { currentUserSelector } from '../../store/selectors/userSelector'
import { User } from '../../lib/types/User'
import { isEmpty } from 'lodash'

type PermissionGateProps = {
  requiredUserClaims?: Partial<Array<'can_access_billing'>>
  requiredAgencyClaims?: string[]
  requiredDealershipClaims?: string[]
  children: React.ReactNode
}

const checkUserClaim = (
  userClaims: PermissionGateProps['requiredUserClaims'] = [],
  user: User | null,
) => {
  if (!user) return false
  if (user.role_id === 1) return true
  return userClaims?.every((claim) => claim && !!user[claim])
}
export default function PermissionGate({
  requiredUserClaims,
  children,
}: PermissionGateProps) {
  const user = useSelector(currentUserSelector)
  // check if user column includes the claim
  if (!isEmpty(requiredUserClaims) && !checkUserClaim(requiredUserClaims, user))
    return null

  return <>{children}</>
}
